<article class="result-card" [attr.data-tier]="candidate.matchTier" [class.is-selected]="isSelected">
    <header class="card-head">
        <svg class="head-art" viewBox="0 0 640 110" fill="none" preserveAspectRatio="none" aria-hidden="true">
            <path [attr.d]="headerLines[0]" stroke="#9cc6de" stroke-width="1.5"></path>
            <path [attr.d]="headerLines[1]" stroke="#b3dcef" stroke-width="1.5"></path>
            <path [attr.d]="headerLines[2]" stroke="#c4e2ef" stroke-width="1"></path>
        </svg>
        <div class="head-content">
            <!-- Avatar / initials circle removed per the 6-8 client meeting (AGU asked
                 to minimize discrimination signals). The match-tier badge and
                 career-stage chip were removed in the STN card rebuild (client
                 mockup, 2026-08) — tiers stay on the wire for sort/export only. -->
            <div class="identity">
                <h2 class="name">{{ displayName }}</h2>
                <p class="org" *ngIf="candidate.jobTitle || candidate.organization">
                    <ng-container *ngIf="candidate.jobTitle as t">{{ t }}</ng-container>
                    <ng-container *ngIf="candidate.jobTitle && candidate.organization">, </ng-container>
                    <ng-container *ngIf="candidate.organization as o">{{ o }}</ng-container>
                </p>
                <p class="loc" *ngIf="locationText">{{ locationText }}</p>
                <p
                    class="contact-status"
                    data-testid="contact-status"
                    [class.failure]="contactStatusIsFailure"
                    *ngIf="contactStatusText">
                    {{ contactStatusText }}
                </p>
            </div>
            <label class="select-toggle" [attr.aria-label]="'Select ' + displayName">
                <input
                    type="checkbox"
                    [checked]="isSelected"
                    (change)="OnSelectionToggle($event)" />
            </label>
        </div>
    </header>

    <div class="card-body">
        <!-- "Show more" opens the experience drawer (STN mockup) — Things to
             Look Into lives there now. -->
        <maps-why-suggested-box
            [text]="candidate.whySuggested ?? null"
            [failed]="summariesFailed"
            [moreOpensExternal]="true"
            (showMore)="viewExperience.emit()"
            (retry)="summariesRetry.emit()"></maps-why-suggested-box>

        <maps-recent-roles
            [roles]="candidate.employmentHistory"
            (moreClicked)="viewExperience.emit()"></maps-recent-roles>

        <maps-profile-links [candidate]="candidate"></maps-profile-links>

        <footer class="actions">
            <!-- Opens the contact modal (live send since the 2026-08 finish
                 line) — the mailto link left per client direction 2026-08-11. -->
            <button
                type="button"
                class="btn primary"
                data-testid="contact"
                (click)="contact.emit()">
                Contact
            </button>
            <button
                type="button"
                class="btn secondary"
                data-testid="view-experience"
                (click)="viewExperience.emit()">
                View Details
            </button>
        </footer>
    </div>
</article>
